// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3vi3k","inner":"Form_inner__2pKW_","range":"Form_range__2etT7","name":"Form_name__4nUIW","actions":"Form_actions__3obP0"};